import { render, staticRenderFns } from "./UpdateInflation.vue?vue&type=template&id=50a55430&"
import script from "./UpdateInflation.vue?vue&type=script&lang=js&"
export * from "./UpdateInflation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports